<template>
  <a-modal
    v-model="open"
    :bodyStyle="{
      padding: '30px 30px 30px 30px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: 'white'
    }"
    :footer="null"
    :maskClosable="false"
    destroy-on-close
  >
    <template #closeIcon></template>
    <img
      width="390"
      height="280"
      src="@/assets/auth_success.png"
    />
    <div class="title">{{ $t('layout.guideLayout.bindSuccess') }}</div>
    <div class="content">
      <p>{{ $t('layout.guideLayout.waitText1') }}</p>
      <p>{{ $t('layout.guideLayout.waitText2') }}</p>
    </div>
    <div class="footer">
      <a-button
        @click.prevent="handleJump"
        type="primary"
      >
        {{ $t('layout.guideLayout.linkJump') }}
      </a-button>
      <a
        @click="handleBindMore"
        class="link"
      >
        {{ $t('layout.guideLayout.btnBindMore') }}
      </a>
    </div>
  </a-modal>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      open: false
    }
  },
  computed: {
    ...mapGetters(['serviceId', 'systemCode', 'microApps'])
  },
  methods: {
    handleBindMore() {
      const key = process.env.NODE_ENV === 'production' ? '83053' : '11114437'
      const pane = {
        path: `/entry/${this.serviceId}/${this.systemCode}/iframe#/m_${key}`,
        systemName: 'iframe',
        menuName: { zh_CN: '店铺授权', en_US: '店铺授权', ko_KR: '店铺授权' },
      }
      this.$store.dispatch('entry/SetActiveAsync', pane)
      this.$store.dispatch('getGuideProcess', { serviceId: this.serviceId })
      this.open = false
    },
    handleJump() {
      this.$emit('jumpOrder')
      this.$store.dispatch('getGuideProcess')
      this.$store.dispatch('entry/SetActiveAsync', {
        path: `/entry/${this.serviceId}/${this.systemCode}/amazon#/setSail/index`
      })
    }
  }
}
</script>

<style lang="less" scoped>
.home-ant-btn-primary:hover {
  background-color: #1f56a5;
  border: #1f56a5;
}
.title {
  font-size: 22px;
  margin-top: -30px;
  font-weight: bold;
  color: #000;
}
.content {
  margin-top: 8px;
  text-align: center;
  font-size: 14px;
  color: #000;
}
.footer {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 10px;
  font-size: 14px;
  .link {
    color: #000;
    margin-top: 8px;
    font-size: 12px;
    text-decoration: underline;
    &:hover {
      color: #1e5af9;
    }
  }
}
</style>
